module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"departments":"Mūsų padaliniai"},"en":{"departments":"Our branches"}}')
  delete Component.options._Ctor
}
